module.exports = __webpack_public_path__ + "img/cmx-annonces.36ab41fd.webp";